/**
 * Logos 2026 - Tab functionality
 * Updates the section heading when a logo tab is clicked
 */
(function () {
  function initLogosTabs() {
    document.querySelectorAll('.logos_2026').forEach(function (section) {
      const heading = section.querySelector('[data-logos-heading]');
      const tabs = section.querySelectorAll('.logos_tab_2026');

      if (!heading || !tabs.length) return;

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const tabText = this.getAttribute('data-tab-text');

          if (!tabText) {
            tabs.forEach(function (t) {
              t.classList.remove('active');
            });
            this.classList.add('active');
            return;
          }

          // Fade out
          heading.classList.add('fade-out');

          setTimeout(function () {
            heading.textContent = tabText;
            heading.classList.remove('fade-out');

            tabs.forEach(function (t) {
              t.classList.remove('active');
            });
            this.classList.add('active');
          }.bind(this), 250);
        });
      });
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogosTabs);
  } else {
    initLogosTabs();
  }

  // Re-run when Shopify theme editor loads dynamic sections
  document.addEventListener('shopify:section:load', initLogosTabs);
})();
